import { Builder } from '@builder.io/react';

import WordpressBlogZipcodeField from './wordpress-blog-zipcode-field';

Builder.registerComponent(WordpressBlogZipcodeField, {
  name: 'WordpressBlogZipcodeField',
  friendlyName: 'Wordpress Blog Zipcode Field',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
      defaultValue: 'Looking for Health Insurance?',
    },
    {
      name: 'subtitle',
      type: 'string',
      required: true,
      defaultValue: "Find affordable healthcare that's right for you",
    },
    {
      name: 'buttonCta',
      type: 'string',
      required: true,
      defaultValue: 'Search Now',
    },
    {
      name: 'popUnderUrl',
      type: 'string',
      required: true,
      defaultValue:
        'https://www.healthcare.com/healthcare-insurance/survey/?zip={{zipCode}}',
      description:
        'The URL to open in a pop-under when the user clicks the button. Use {{zipCode}} to insert the entered zip code.',
    },
    {
      name: 'popOutUrl',
      type: 'string',
      required: false,
      description:
        'The URL to open in a new tab when the user clicks the button. Use {{zipCode}} to insert the entered zip code.',
    },
  ],
});
